import { createSelector, OutputSelector } from 'reselect'
import { ITagsState, IShipmentNoteTags, ITag } from 'types'

interface IStore {
  shipmentNoteTags: ITagsState
}

interface SelectShipmentNoteTagsSelector
  extends OutputSelector<IStore, IShipmentNoteTags[], (res: ITagsState) => ITag[]> {}

const selectTags = (state: IStore) => state.shipmentNoteTags

export const selectShipmentNoteTags: SelectShipmentNoteTagsSelector = createSelector(
  selectTags,
  state => {
    const { list = [] } = state || { list: [] }
    return list.map(tag => {
      return {
        ...tag,
        type: '@',
        description: `${tag.firstName} ${tag.lastName}`,
      }
    })
  }
)

export const selectShipmentNoteUserTags: SelectShipmentNoteTagsSelector = createSelector(
  selectTags,
  state => {
    const { list = [] } = state || { list: [] }
    return list
      .filter(tag => tag.type !== 'Group')
      .map(tag => {
        return {
          ...tag,
          type: '@',
          description: `${tag.firstName} ${tag.lastName}`,
        }
      })
  }
)
